import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Result.css';

export default function Result() {
  const location = useLocation();
  const navigate = useNavigate();
  const result = location.state || { correct: 0, total: 10, percentage: 0, passed: false };

  const [animatedScore, setAnimatedScore] = useState(0);
  const circumference = 326.7;

  useEffect(() => {
    // Animar el score de 0 al valor real
    const timer = setTimeout(() => {
      setAnimatedScore(result.percentage);
    }, 300);
    return () => clearTimeout(timer);
  }, [result.percentage]);

  const offset = circumference - (animatedScore / 100) * circumference;

  return (
    <div className="result">
      <div className="result__card ik-fade-in-up">
        <div className="result__icon">
          {result.passed ? '🎉' : '💪'}
        </div>

        <div className="result__ring">
          <svg width="120" height="120" viewBox="0 0 120 120">
            <circle
              cx="60" cy="60" r="52"
              fill="none"
              stroke="var(--ik-gray-200)"
              strokeWidth="10"
            />
            <circle
              cx="60" cy="60" r="52"
              fill="none"
              stroke={result.passed ? 'var(--ik-teal-light)' : 'var(--ik-warning)'}
              strokeWidth="10"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%',
                transition: 'stroke-dashoffset 1.2s cubic-bezier(0.16, 1, 0.3, 1)',
              }}
            />
          </svg>
          <div className="result__ring-text">
            <div className="result__score-num">{animatedScore}%</div>
            <div className="result__score-label">Puntaje</div>
          </div>
        </div>

        <h2 className="result__title">
          {result.passed ? '¡Felicitaciones!' : 'Buen intento'}
        </h2>

        <p className="result__sub">
          {result.passed
            ? `Aprobaste con ${result.percentage}% (${result.correct}/${result.total} correctas). El equipo Impekble te contactará pronto por WhatsApp para coordinar tus días de prueba.`
            : `Obtuviste ${result.percentage}% (${result.correct}/${result.total} correctas). Necesitas 70% para avanzar. Te mantendremos en nuestra base para futuras oportunidades.`
          }
        </p>

        {result.passed && (
          <div className="ik-alert ik-alert--success" style={{ textAlign: 'left', marginTop: 20 }}>
            📱 <strong>Próximo paso:</strong> Recibirás un WhatsApp en las próximas 24hrs con los detalles de tus 10 días de prueba con un entrenador.
          </div>
        )}

        <button
          className="ik-btn ik-btn--primary ik-btn--block"
          style={{ marginTop: 28 }}
          onClick={() => navigate('/')}
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
}
